import React from 'react';
import PropTypes from 'prop-types';

export default function TrackIcon(props) {
  return (
    <svg width={props.width} height={props.width} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M14.8257 17.0045C15.9491 17.374 16.941 17.6093 18.3662 18.0299C17.8187 24.674 11.2768 22.0354 14.8257 17.0045ZM20.6667 10.9012C20.5929 8.90624 20.227 6.28934 17.3126 6.69939C15.9465 7.0418 14.937 8.48273 14.4623 10.9688C14.2015 12.3357 14.3532 14.2543 14.6607 15.4045C14.9416 16.215 14.8461 16.1651 15.1479 16.3191C16.3161 16.5718 17.4727 16.8516 18.6504 17.1369C19.8469 16.3255 20.5417 14.2916 20.6667 10.9012ZM10.0061 10.7481C10.3134 9.59778 10.465 7.67914 10.2044 6.31239C9.72999 3.82621 8.72044 2.38505 7.35401 2.04287C4.43965 1.63283 4.07377 4.24968 4 6.24472C4.00076 8.62364 4.81991 11.6691 6.01648 12.4804C7.19415 12.1951 9.09572 11.8201 9.51914 11.6625C9.78199 11.5235 9.71336 11.6224 10.0061 10.7481ZM6.3003 13.3736C6.84762 20.0176 13.3896 17.379 9.84069 12.3483C8.71733 12.7178 7.72547 12.953 6.3003 13.3736Z" fill={props.color || '#000000'} />
    </svg>
  );
}

TrackIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
};

TrackIcon.defaultProps = {
  color: '#202020',
  width: 24,
};